import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "MainSectionFilterstyle__Container",
  componentId: "sc-1hkfguo-0"
})(["width:350px;"]);
export { Container };